import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "d-flex align-items-center mt-3 mb-2",
  style: {"line-height":"1.3"}
}
const _hoisted_2 = { class: "align-center" }
const _hoisted_3 = { class: "flex-fill mr-3 ml-3 text-truncate" }
const _hoisted_4 = {
  key: 0,
  class: "text-primary font-weight-bold mb-1"
}
const _hoisted_5 = {
  key: 1,
  class: "text-truncate"
}
const _hoisted_6 = { key: 0 }

import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";


const __default__ = {
    name: "OperatorApplicationDialogTextareaAction"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    icon: {},
    cancelListening: { type: Boolean }
  },
  emits: ["cancel"],
  setup(__props: any, { emit: __emit }) {



let emits = __emit;

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(FontAwesomeIcon, {
        icon: __props.icon,
        class: "text-primary",
        style: {"font-size":"1.5em"},
        light: ""
      }, null, 8, ["icon"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.$slots.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "title")
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.default)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : _createCommentVNode("", true)
    ]),
    (__props.cancelListening)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            link: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('cancel')))
          }, {
            default: _withCtx(() => [
              _createVNode(FontAwesomeIcon, { icon: "times" })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})